var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.769191 9.50251C0.831407 9.31587 1.00028 9.19142 1.19581 9.19142H9.70154L12.3235 1.02329C12.4479 0.658902 13.0523 0.658902 13.1768 1.02329L15.7987 9.19142H24.3045C24.5 9.19142 24.6688 9.31585 24.7311 9.50251C24.7844 9.68027 24.7222 9.88471 24.5711 10.0002L17.6828 15.0486L20.3137 23.2256C20.457 23.6144 19.9481 23.9755 19.6293 23.7144L12.7499 18.666L5.87044 23.7144C5.54714 23.9788 5.04273 23.6155 5.18608 23.2256L7.81692 15.0486L0.928663 10.0002C0.777567 9.8847 0.715351 9.68027 0.768679 9.50251H0.769191Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.703b29e697afa6c348ff5647ceffb1ab.svg";
export { ForwardRef as ReactComponent };